import { useLocalStorageState } from 'ahooks';
import { useCallback } from 'react';
import { useCurrentOrganizationId } from 'hooks/use-current-organization-id';

const useLocalStorageForOrganization = <T>(localStorageKey: string) => {
  const organizationId = useCurrentOrganizationId();

  const [localStorageValue, setLocalStorageValue] = useLocalStorageState<Record<string, T>>(localStorageKey, {
    defaultValue: {}
  });

  const setValueForOrganization = useCallback(
    (value: T) => {
      setLocalStorageValue(prev => ({
        ...prev,
        [organizationId]: value
      }));
    },
    [organizationId, setLocalStorageValue]
  );

  return [localStorageValue![organizationId], setValueForOrganization] as const;
};

export default useLocalStorageForOrganization;
